import { shouldPolyfill } from "@formatjs/intl-locale/should-polyfill";
if (shouldPolyfill()) {
  import("@formatjs/intl-locale/polyfill");
}

import "@old/shared/constants.js.erb";
window["tiz"] = {
  filter: function () {},
  service: function () {},
  factory: function () {},
  config: function () {},
};
import retailerConfig from "@retailer/constants.js";
import distributorConfig from "@distributor/constants.js";

let App;
import("svelte").then(module => {
  import("@modern/App.svelte").then(module => {
    let start;
    let retailerStart = document.getElementById("modern_retailer_app");
    let distributorStart = document.getElementById("modern_distributor_app");
    let demoStart = document.getElementById("modern_demo_app");

    if (retailerStart && window["PRELOADED_RETAILERS"]) {
      retailerConfig(window["C"]);
      start = retailerStart;
    } else if (retailerStart) {
      start = retailerStart;
    } else if (distributorStart) {
      distributorConfig(window["C"]);
      start = distributorStart;
    } else if (demoStart) {
      start = demoStart;
    } else {
      return;
    }

    App = module.default;

    const wrapper = new App({
      target: start,
    });
  });
});
